import React from 'react';
import { Rate } from 'antd';

export default function StarRating({ value, count }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      <Rate disabled defaultValue={value} allowHalf style={{ fontSize: 14, color: '#FAA01E' }} />
      {count != null && (
        <span style={{ fontSize: 13, color: '#999' }}>({count})</span>
      )}
    </span>
  );
}
